export default "__VITE_ASSET__Fr3gRDkA__"